import React, { Component } from 'react';
import { Form, Input, message, Modal, Row } from 'antd';

import { queryTransferContractConfirm, queryTransferContractRefuse } from '@api/xxcrm/contract';

const FormItem = Form.Item;
class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  submit = () => {
    const data = this.props.form.getFieldsValue();
    const { record, deal } = this.props;
    data.uuid = record.uuid;
    this.props.form.validateFields(() => {
      if (deal === 'confirm') {
        this.transferContractConfirm(data);
      } else {
        this.transferContractRefuse(data);
      }
    });
  };

  /**
   * 转移合同确认
   */
  transferContractConfirm = params => {
    queryTransferContractConfirm(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.props.handSubmit();
      } else {
        message.error(res.message);
      }
    });
  };

  /**
   * 转移合同拒绝
   */
  transferContractRefuse = params => {
    queryTransferContractRefuse(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.props.handSubmit();
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { cancel, record, deal } = this.props;
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
    };
    const title = deal === 'confirm' ? '接收合同' : '拒绝合同';
    return (
      <Modal
        title={title}
        width={400}
        visible
        onCancel={cancel}
        onOk={this.submit}
        maskClosable={false}
      >
        <Form className="modal" layout="inline">
          <Row>
            <FormItem label="转移人" {...formItemLayout}>
              <p>{record.belonging}</p>
            </FormItem>
          </Row>
          <Row>
            <FormItem label="转移事由" {...formItemLayout}>
              <p>{record.transferRemark}</p>
            </FormItem>
          </Row>
          <Row>
            <FormItem {...formItemLayout} label="备注">
              {getFieldDecorator('transferResultRemark')(
                <Input.TextArea
                  type="textarea"
                  size="large"
                  autosize={{ minRows: 2 }}
                  style={{ marginLeft: '5px' }}
                  maxLength={1000}
                />,
              )}
              <span style={{ fontSize: '12px', color: '#999' }}>*最多可输入1000字</span>
            </FormItem>
          </Row>
        </Form>
      </Modal>
    );
  }
}
export default Form.create()(Index);



// WEBPACK FOOTER //
// ./src/components/xianxing/contract/ModalDealTransfer.js